import { render, staticRenderFns } from "./ApprovalCommentDialogTrigger.vue?vue&type=template&id=c0a7c028&"
import script from "./ApprovalCommentDialogTrigger.vue?vue&type=script&lang=js&"
export * from "./ApprovalCommentDialogTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
